import React, { useCallback, useMemo } from 'react'
import { FilteredPropertyData } from '../../../types/PropertyData'
import MultipleChoice from './MultipleChoice'

export type OptionsDetailedProps = {
  propertyData: FilteredPropertyData
  value?: string
  setValue?: (nextValue: string) => void
}

const OptionsDetailed: React.FC<OptionsDetailedProps> = ({ propertyData, value, setValue }) => {
  const _value = useMemo(() => (value ? [value] : undefined), [value])
  const _setValue = useCallback(
    (nextValue: string[]) => {
      if (nextValue[0]) {
        setValue?.(nextValue[0])
      }
    },
    [setValue]
  )

  return <MultipleChoice singleChoice propertyDatas={propertyData.values} value={_value} setValue={_setValue} />
}

export default OptionsDetailed
